import React from "react";

const products = [
  {
    title: "Bettschutzeinlagen",
    description: "Saugstark, hautfreundlich und diskret. Für Komfort Tag und Nacht.",
    image:
      "https://images.unsplash.com/photo-1633539091259-dc7024887566?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxmb2xkZWQlMjB3aGl0ZSUyMG1lZGljYWwlMjBibGFua2V0fGVufDB8fHx8MTc3NzIwNTc4MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Einmalhandschuhe",
    description: "Latexfrei, puderfrei und reißfest. Für hygienisches Pflegen.",
    image:
      "https://images.pexels.com/photos/7722601/pexels-photo-7722601.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Hände- & Flächendesinfektion",
    description: "Wirksamer Schutz vor Keimen – schonend zur Haut.",
    image:
      "https://images.pexels.com/photos/3962349/pexels-photo-3962349.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Mund-Nasen-Schutz",
    description: "Atmungsaktive Masken in zertifizierter Qualität.",
    image:
      "https://images.pexels.com/photos/5475819/pexels-photo-5475819.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Schutzschürzen",
    description: "Flüssigkeitsdichte Einmalschürzen für die tägliche Pflege.",
    image:
      "https://images.unsplash.com/photo-1587497203441-4fd44b43caf8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxkaXNwb3NhYmxlJTIwbWVkaWNhbCUyMGFwcm9ufGVufDB8fHx8MTc3NzIwNTc4OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Fingerlinge",
    description: "Praktischer Schutz für punktgenaue Anwendungen.",
    image:
      "https://images.pexels.com/photos/7580249/pexels-photo-7580249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const Inhalte = () => {
  return (
    <section
      id="inhalte"
      data-testid="inhalte-section"
      className="relative py-24 sm:py-32 bg-[#F4F1EB]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3FA66D] mb-5">
            Inhalte der Box
          </div>
          <h2
            data-testid="inhalte-headline"
            className="text-4xl sm:text-5xl font-medium leading-tight text-[#1A1A1F]"
          >
            Sechs Produkte.{" "}
            <span className="text-gradient-dark">Eine Box.</span>{" "}
            <span className="text-gradient-green">Jeden Monat neu.</span>
          </h2>
          <p className="mt-5 text-[#5A5F66] text-base sm:text-lg">
            Stellen Sie Ihre Pflegebox individuell zusammen – aus geprüften
            Hilfsmitteln in Apothekenqualität.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => (
            <article
              key={p.title}
              data-testid={`product-card-${p.title}`}
              className="group relative overflow-hidden rounded-3xl bg-white border border-[#1A1A1F]/[0.06] hover:border-[#3FA66D]/30 hover:shadow-[0_18px_40px_-20px_rgba(63,166,109,0.25)] transition-all duration-500"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-medium text-[#1A1A1F]">{p.title}</h3>
                <p className="mt-2 text-sm text-[#5A5F66] leading-relaxed">
                  {p.description}
                </p>
              </div>
              <div className="absolute top-4 right-4 inline-flex items-center px-3 py-1 rounded-full bg-white/90 backdrop-blur border border-[#3FA66D]/20 text-[11px] font-semibold text-[#2E8B5A] uppercase tracking-wider">
                Inklusive
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Inhalte;
